import { ChangeEvent, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Input } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";

const Linker = () => {
  const params = useParams();
  const [overrideUrl, setOverrideUrl] = useState<string | null>(null);

  const decodedUrl = useMemo(() => {
    if (overrideUrl) return overrideUrl;
    return params.link ? decodeURI(params.link) : null;
  }, [params.link, overrideUrl]);

  const handleChange = (
    value: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    // add alternative paths.
    setOverrideUrl(`ltd.meliora.${value.target.value}://debug/true`);
  };

  return (
    <PageContainer title="Linker">
      <div style={{gap: 8}}>
       <h3>Override:</h3>
      <Input onChange={handleChange} placeholder="Enter App identifier" />
      {decodedUrl && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 20 }}>
          <h2>Automatic:</h2>
          <a
            href={decodedUrl}
            rel="noreferrer"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = decodedUrl;
            }}
          >Open</a>
          <h2>Manual:</h2>
          <h3>{decodedUrl}</h3>
        </div>
      )}
      </div>
    </PageContainer>
  );
};

export default Linker;
